import { render, staticRenderFns } from "./shang-pin-zu-zhuang.vue?vue&type=template&id=3cd8ac4e&scoped=true"
import script from "./shang-pin-zu-zhuang.vue?vue&type=script&lang=js"
export * from "./shang-pin-zu-zhuang.vue?vue&type=script&lang=js"
import style0 from "./shang-pin-zu-zhuang.vue?vue&type=style&index=0&id=3cd8ac4e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd8ac4e",
  null
  
)

export default component.exports